import { render, staticRenderFns } from "./HotelDetailsRoomsTab.vue?vue&type=template&id=785c8af2&"
import script from "./HotelDetailsRoomsTab.vue?vue&type=script&lang=js&"
export * from "./HotelDetailsRoomsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports